<template>
  <div class="flex flex-col gap-2">
    <!-- Header at top when closed or headerAtBottom is false -->
    <template v-if="!isOpen || !headerAtBottom">
      <div class="flex items-center cursor-pointer" @click="toggleIsOpen">
        <i v-if="isOpenCloseIconOnLeft" :class="getIcon()" class="flex-none mx-2 text-action"></i>
        <div class="flex-1">
          <slot name="header" :isOpen="isOpen"></slot>
          <i v-if="!isOpenCloseIconOnLeft" :class="getIcon()" class="mx-2 text-action"></i>
        </div>
      </div>
      <div v-if="$slots.headerSecondary" @click="toggleIsOpen">
        <slot name="headerSecondary" :isOpen="isOpen"></slot>
      </div>
    </template>

    <!-- Content -->
    <div v-show="isOpen">
      <slot></slot>
    </div>

    <!-- Header at bottom when open and headerAtBottom is true -->
    <template v-if="isOpen && headerAtBottom">
      <div class="flex items-center cursor-pointer" @click="toggleIsOpen">
        <i v-if="isOpenCloseIconOnLeft" :class="getIcon()" class="flex-none mx-2 text-action"></i>
        <div class="flex-1">
          <slot name="header" :isOpen="isOpen"></slot>
          <i v-if="!isOpenCloseIconOnLeft" :class="getIcon()" class="mx-2 text-action"></i>
        </div>
      </div>
      <div v-if="$slots.headerSecondary" @click="toggleIsOpen">
        <slot name="headerSecondary" :isOpen="isOpen"></slot>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch } from "vue";
const emit = defineEmits(["expansionChange"]);

const props = defineProps({
  isOpen: Boolean,
  isOpenCloseIconOnLeft: {
    type: Boolean,
    default: true
  },
  headerAtBottom: {
    type: Boolean,
    default: false
  }
});

const isOpen = ref(props.isOpen);

const toggleIsOpen = () => {
  isOpen.value = !isOpen.value;
  emit("expansionChange", isOpen.value);
};

watch(
  () => props.isOpen,
  (value) => {
    isOpen.value = value;
  }
);

const getIcon = () => (isOpen.value ? "fas fa-chevron-up" : "fas fa-chevron-down");
</script>
